import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import FilterPanel, { PanelBody } from "../../../../sharedComponents/filterPanel";
import JournalForm from "./nutritionJournalForm";

const EditNutritionJournal = ({ initialValues, toggleEditJournal = false, setToggleEditJournal, onUpdate }) => {
	return (
		<FilterPanel
			className="add-exercise-panel hide-sub-header"
			show={toggleEditJournal}
			toggle={setToggleEditJournal}
			title="Edit Nutrition Journal"
			closeBtn>
			<PanelBody className="d-flex flex-column">
				<JournalForm
					setToggleEditJournal={setToggleEditJournal}
					editTime={initialValues && initialValues.time}
					initialValues={initialValues ? initialValues : null}
					date={initialValues ? initialValues.date : null}
					onUpdate={onUpdate}
				/>
			</PanelBody>
		</FilterPanel>
	);
};

const mapDispatchToProps = {};

export default reduxForm({
	form: "EditNutritionJournalForm",
	enableReinitialize: true
})(
	connect(
		null,
		mapDispatchToProps
	)(EditNutritionJournal)
);
